import { render, staticRenderFns } from "./webstore.vue?vue&type=template&id=12ab4dd1&"
import script from "./webstore.vue?vue&type=script&lang=js&"
export * from "./webstore.vue?vue&type=script&lang=js&"
import style0 from "./webstore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
